// ================= plugin import =============== //
import React, { useEffect, useState, useContext } from 'react'
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { notification } from 'antd';

// ================== module import ================ //
import SAISVG from '../../../../../_template/helpers/CommonFunction';
import { MenuComponent } from '../../../../../_template/assets/ts/components/MenuComponent';
import { ToggleComponent } from '../../../../../_template/assets/ts/components/ToggleComponent';
// import { AppContext } from '../../../../routing/AuthContext';
import {getShortForm} from '../../../../component/common/Helper';

// ==================== component import =============== //
import CredentialPopup from '../../../../component/common/CredentialPopup';
import NoDataFound from '../../../../component/common/NoDataFound';
import Pagination from '../../../../component/common/pagination/Pagination';

const SystemUserTable = (props) => {
    useEffect(() => {
        setTimeout(() => {
            MenuComponent.reinitialization()
            ToggleComponent.reinitialization()
        }, 500);
    });
    const {
        user_full_name , 
        user_email, 
        username, 
        manage_permission, 
        assign_product,
        assign_agent,
        password,
        unique_id,
        active_status,
        user_type
    } = props;

    // let assignProductHtml = '';
    // if( assign_product.length > 0){
    //     assignProductHtml = assign_product.map((assignProduct) => 
    //         <span className="me-2" key={assignProduct.id}>
    //             <div className="badge badge-light-primary fw-bold mb-1">
    //                 {assignProduct.product_name}
    //             </div>
    //         </span>
    //     )
    // }
    let assignAgentHtml = '';
    if( assign_agent.length > 0){
        assignAgentHtml = assign_agent.map((assignAgent) => 
            <span className="me-2" key={assignAgent.id}>
                <div className="badge badge-light-primary fw-bold mb-1">
                    {assignAgent.bot_name}
                </div>
            </span>
        )
    }

    const [managePermission, setManagePermission] = useState([]);
    useEffect(() => {
        const newPermissions = [];
        if (manage_permission.allow_change_permission === 'Y') {
            newPermissions.push("Permission Change");
        }
        if (manage_permission.allow_data_add === 'Y') {
            newPermissions.push("Add New");
        }
        if (manage_permission.allow_data_delete === 'Y') {
            newPermissions.push("Delete Data");
        }
        if (manage_permission.allow_data_edit === 'Y') {
            newPermissions.push("Edit Data");
        }
        setManagePermission(newPermissions);
    }, [manage_permission]);

    let permissionHtml = '';
    if(managePermission.length > 0){
        permissionHtml = managePermission.map((permission) => 
            <span className="me-2"  key={uuidv4()}>
                <div className="badge badge-light-primary fw-bold mb-1">
                    {permission}
                </div>
            </span>
        )
    }

    return (
        <>
            <tr className="">
                <td className="d-flex align-items-center border-none">
                    <div className="symbol rounded symbol-50px overflow-hidden me-3">
                        <a>
                            <div className="symbol-label fs-3 bg-light-dark text-dark fw-bold text-uppercase">
                                {getShortForm(user_full_name)} 
                            </div>
                        </a>
                    </div>
                    <div className="d-flex flex-column">
                        <a className="text-gray-800  mb-1">
                            {user_full_name}
                        </a>
                        <span>
                            <div className="badge badge-light-dark fw-bold">
                                {user_type === 'D' ? 'Developer' : user_type === 'S' ? 'System User' : ''}
                            </div>
                        </span>
                    </div>
                </td>
                {/* <td>
                    {assignProductHtml}
                </td> */}
                <td>{assignAgentHtml}</td>
                <td>
                    {permissionHtml}
                </td>
                <td>
                    <div className="d-flex mb-4 float-end">
                        <div className="form-check form-switch m-auto">
                            <input 
                                className="form-check-input" 
                                type="checkbox" 
                                value= "" 
                                defaultChecked={active_status === 'Y' ? true : false}
                                onChange={(event) => {
                                    const isChecked = event.target.checked;
                                    props.statusOnChange(username, isChecked);
                                }}
                            />
                        </div>
                        <button 
                            className="btn btn-sm btn-icon btn-light-dark me-3 px-4"
                            data-sai-menu-trigger='click'
                            data-sai-menu-placement='bottom-end'
                            data-sai-menu-flip='top-end'
                        >
                            <SAISVG path="media/icons/duotune/general/gen047.svg" className="svg-icon-muted svg-icon-2" />
                        </button>
                        <CredentialPopup
                            title='System User Credential'
                            username={username}
                            password={atob(password)}
                        />
                        <button 
                            className="btn btn-sm btn-icon btn-light-primary me-3 px-4"
                            onClick={ () => props.systemUserUpdateOnClick(unique_id)}
                        >
                            <SAISVG path="media/icons/duotune/art/art005.svg" className="svg-icon-muted svg-icon-2" />
                        </button>
                        <button 
                            className="btn btn-sm btn-icon btn-light-danger px-4"
                            onClick={(e) => { e.preventDefault(); props.systemUserDeleteOnClick({
                                type: 'Y',
                                unique_id : unique_id,
                                user_name : username
                            }) }}
                        >
                            <SAISVG path="media/icons/duotune/general/gen027.svg" className="svg-icon-muted svg-icon-2" />
                        </button>
                    </div>
                </td>
            </tr>
        </>
    );
}


const SystemUserList = (props) => {
    const [api, contextHolder] = notification.useNotification();
    const api_base_url = process.env.REACT_APP_API_URL;
    const loginUserType = localStorage.getItem('type');
    // const { localStorageValue }  = useContext(AppContext);

    const { searchData, isFormSubmited } = props;

    const [page, setPage] = useState(1);
    const dataLimit = 50;

    const [ paginationData, setPaginationData ] = useState({})
    const [ systemUserData, setSystemUserData ] = useState([]);

    const [ systemUserUpdateId , setSystemUserUpdateId] = useState('');

    const getSystemUserData = async () => {
        let apiToken = '';
        if(loginUserType === 'A') {
            apiToken = localStorage.getItem('token')
        } else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }
        var api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };
        var data = {
            searchData : searchData,
            page : page,
            limit : dataLimit,
            system_user_update_id: systemUserUpdateId,
            sass_id: localStorage.getItem('sass_id')
        }
        await axios.post(`${api_base_url}admin/get-system-user-list`, data, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                if(systemUserUpdateId === ''){
                    setSystemUserData(res.data.data.system_user_data);
                    setPaginationData({
                        current_pages : res.data.data.current_pages,
                        total_data_count : res.data.data.total_count,
                        total_pages : res.data.data.total_pages,
                        limit : res.data.data.limit,
                        data_length : res.data.data.system_user_data.length
                    })
                    props.refreshSuccess()
                    props.totalSystemUserCount(res.data.data.total_count)
                }
                else{
                    var systemUserUpdateData = res.data.data.system_user_data[0];
                    props.systemUserUpdateData(systemUserUpdateData)
                    setSystemUserUpdateId('')
                }
            } else if(res.data.status === 'error') {
                console.error('error')
            }
        })
        .catch((error) => {
            console.error(error);
        })
    }

    useEffect( () => {
        getSystemUserData();
    },[searchData, isFormSubmited, page, systemUserUpdateId])

    // ------------- system user update ----------- //
    const systemUserUpdateHandler = (updateId) => {
        setSystemUserUpdateId(updateId)
    }

    // -------- system user status change ------- //
    const statusOnChangeHandler = async (userName, e) => {
        let apiToken = '';
        if(loginUserType === 'A') {
            apiToken = localStorage.getItem('token')
        } else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }
        var api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };
        var data = {
            user_name : userName,
            status : e ? 'Y' : 'N',
            sass_id: localStorage.getItem('sass_id')
        }

        await axios.post(`${api_base_url}admin/update-system-user-active-status`, data, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                api["success"]({
                    message: 'Success',
                    description: res.data.message
                });
            } else if(res.data.status === 'error') {
                console.error('error')
            }
        })
        .catch((error) => {
            console.error(error);
        })
    }

    // -------- system user delete -------- //
    const systemUserDeleteHandler = async (param) => {
        const productDeleteSwal = await Swal.fire({
            title: 'Are you sure?',
            text: 'You won’t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        });
        if (productDeleteSwal.isConfirmed) {
            let apiToken = '';
            if(loginUserType === 'A') {
                apiToken = localStorage.getItem('token')
            } else if(loginUserType === 'SA') {
                apiToken = localStorage.getItem('systemAdminToken')
            }
            var api_headers = {
                headers: { 
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "x-access-token" : apiToken
                }
            };
            param.sass_id = localStorage.getItem('sass_id');

            await axios.post(`${api_base_url}admin/system-user-delete`, param, api_headers)
            .then(async (res) => {
                if(res.data.status === 'success') {
                    api["success"]({
                        message: 'Success',
                        description: res.data.message
                    });
                    getSystemUserData();
                } else if(res.data.status === 'error') {
                    console.error('error')
                }
            })
            .catch((error) => {
                console.error(error);
            }) 
        }
    }


    // ----- set system user data ------ //
    let systemUserHtml = (
        <tr>
            <td colSpan="4" className="text-center">
                <NoDataFound className="w-30" setHtml="No system user found" />
            </td>
        </tr>
    );

    if(systemUserData.length > 0){
        systemUserHtml = systemUserData.map((systemUser) => 
            <SystemUserTable
                key={systemUser.unique_id}
                unique_id={systemUser.unique_id}
                user_full_name={systemUser.user_full_name}
                username={systemUser.username}
                user_email={systemUser.user_email}
                password={systemUser.password}
                user_type={systemUser.user_type}
                manage_permission={systemUser.manage_permission}
                assign_product={systemUser.key_value_object}
                assign_agent={systemUser.assigned_agent}
                systemUserUpdateOnClick={systemUserUpdateHandler}
                active_status={systemUser.active_status}
                statusOnChange={statusOnChangeHandler}
                systemUserDeleteOnClick={systemUserDeleteHandler}
            />
        )
    }

    // ------- pagination ----- //
    const pagechangeHandler = (pageNumber, type) => {
        if( type === 'previous' ){
            setPage((c_page) => c_page - 1)
        }else if( type === 'page' ){
            setPage(pageNumber)
        }
        else if( type === 'next' ){
            setPage((c_page) => c_page + 1)
        }
    }
    return (
        <>
            <div className="row mt-5">
                <div className="col-md-12">
                    <div className="card border">
                        <div className="card-body py-4">
                            <div id="sai_table_users_wrapper" className="dataTables dt-bootstrap4 no-footer">
                                <div className="table-responsive">
                                    <table className="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
                                        <thead>
                                            <tr className="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
                                                <th className="w-300px sorting">User Details</th>
                                                {/* <th className="w-250px sorting">Assigned Product</th> */}
                                                <th className="w-250px sorting">Assigned Agent</th>
                                                <th className="w-250px sorting">Action Allowed </th>
                                                <th className="w-200px text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-gray-600 fw-semibold set-system-user-list">
                                            {systemUserHtml}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            { systemUserData.length > 0 &&
                <Pagination
                    pagination_data={paginationData}
                    onClick={pagechangeHandler}
                />
            }

            {contextHolder}
        </>
    )
}

export default SystemUserList